import { j as e } from "../../../_virtual/jsx-runtime.js";
import { cn as n } from "../../../lib/utils.js";
import { useState as m, useRef as p, useLayoutEffect as u } from "react";
import w from "../../../node_modules/react-loading-skeleton/dist/index.js";
import '../../../node_modules/react-loading-skeleton/dist/skeleton.css';/* empty css                                                             */
const R = ({
  isLoading: a,
  children: r,
  circle: f,
  full: o,
  height: h,
  className: c
}) => {
  const [t, l] = m({ width: 0, height: 0 }), s = p(null);
  return u(() => {
    if (s.current instanceof HTMLDivElement) {
      const i = s.current.getBoundingClientRect();
      (t.width !== i.width || t.height !== i.height) && l({ width: i.width, height: i.height });
    }
  }, [r, t]), a ? /* @__PURE__ */ e.jsxs("div", { className: n("skeleton-wrapper", o ? "w-full" : "", c), children: [
    /* @__PURE__ */ e.jsx(
      w,
      {
        width: o ? "100%" : t == null ? void 0 : t.width,
        height: h || (t == null ? void 0 : t.height),
        circle: f
      }
    ),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: n(
          "absolute top-0 left-0",
          o ? "w-full" : "",
          "invisible"
        ),
        ref: s,
        children: r
      }
    )
  ] }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: r });
};
export {
  R as default
};
